spineSymbolAnimator = {};
spineSymbolAnimator.animationPool = [
  {
    poolName: "Empty",
    number: 0,
    pool: [],
    anims: [],
    backings: [],
  },
];
spineSymbolAnimator.currentAnimations = [];
spineSymbolAnimator.gameReels = undefined;
spineSymbolAnimator.slotContainer = undefined;
spineSymbolAnimator.ready = false;
spineSymbolAnimator.callBackDelay = 0;
spineSymbolAnimator.backings = [];

spineSymbolAnimator.symbolIDMap = [
  { id: 0, name: "Ten", anim: 0, scale: 1 },
  { id: 1, name: "Jack", anim: 0, scale: 1 },
  { id: 2, name: "Queen", anim: 0, scale: 1 },
  { id: 3, name: "King", anim: 0, scale: 1 },
  { id: 4, name: "Ace", anim: 0, scale: 1 },
  { id: 5, name: "Lure", anim: 0, scale: 1 },
  { id: 6, name: "Float", anim: 0, scale: 1 },
  { id: 7, name: "Rod", anim: 0, scale: 1 },
  { id: 8, name: "Tackle", anim: 0, scale: 1 },
  { id: 9, name: "Trawler", anim: 0, scale: 1 },
  { id: 10, name: "Logo", anim: 0, scale: 1 },
  { id: 11, name: "Wild", anim: 0, scale: 1 },
  { id: 12, name: "Bonus", anim: 0, scale: 1 }, //Bonus
  { id: 13, name: "Empty", anim: 0, scale: 1 }, //Mystery
  { id: 14, name: "Fisherman", anim: 0, scale: 1 },
  { id: 15, name: "Respin", anim: 0, scale: 1 },
  { id: 16, name: "Respin", anim: 1, scale: 1 },
  { id: 17, name: "Respin", anim: 2, scale: 1 },
  { id: 18, name: "Coin", anim: 0, scale: 1 },
  { id: 19, name: "LegendaryCatch", anim: 0, scale: 1 }, //LegendaryCatch
  { id: 20, name: "Empty", anim: 0, scale: 1 },
  { id: 100, name: "SmallFish", anim: 0, scale: 1 },
  { id: 101, name: "Carp", anim: 0, scale: 1 },
  { id: 102, name: "Salmon", anim: 0, scale: 1 },
  { id: 103, name: "Trout", anim: 0, scale: 1 },
  { id: 104, name: "Bass", anim: 0, scale: 1 },
  { id: 105, name: "Pike", anim: 0, scale: 1 },
];

spineSymbolAnimator.numCashFish = 6;
spineSymbolAnimator.startCashFishID = 100;
spineSymbolAnimator.fishSymbolMapOffset = [
  { max: 105, offset: 0 },
  { max: 111, offset: 1 },
  { max: 117, offset: 2 },
  { max: 123, offset: 3 },
  { max: 129, offset: 4 },
];

spineSymbolAnimator.fishNames = ["SmallFish", "Carp", "Salmon", "Trout", "Bass", "Pike"];
spineSymbolAnimator.fishSpinePositionOffsets = {
  0: { x: 0, y: 0 }, // size 3
  1: { x: 0, y: 1.5 }, // size 4
  2: { x: 0, y: 0.5 }, // size 5
  3: { x: 0, y: 0 }, // size 6
  4: { x: 0, y: -0.5 }, // size 7
};

spineSymbolAnimator.initialise = function () {
  spineSymbolAnimator.gameReels = gameData.reels;
  spineSymbolAnimator.slotContainer = resourceManager.get("slotContainer:reelContainer");
  spineSymbolAnimator.backingContainer = resourceManager.get("slotContainer:reelContainer:backingContainer");

  //spineSymbolAnimator.createAnim("Clover", 0, ["+1 Clover Anim x5", "+2 Clover Anim x5", "+3 Clover Anim x5"]);
  spineSymbolAnimator.createAnim("Rod", 0, [
    "High_Win_Rod_3x_anim",
    "High_Win_Rod_4x_anim",
    "High_Win_Rod_5x_anim",
    "High_Win_Rod_6x_anim",
    "High_Win_Rod_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Float", 0, [
    "Float_3x_anim",
    "Float_4x_anim",
    "Float_5x_anim",
    "Float_6x_anim",
    "Float_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Fisherman", 0, [
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
    "Fisherman_Regular",
  ]);
  spineSymbolAnimator.createAnim("Trawler", 0, [
    "High_Win_Trawler_3x_anim",
    "High_Win_Trawler_4x_anim",
    "High_Win_Trawler_5x_anim",
    "High_Win_Trawler_6x_anim",
    "High_Win_Trawler_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Logo", 0, [
    "Logo_Symbol_3x_anim",
    "Logo_Symbol_4x_anim",
    "Logo_Symbol_5x_anim",
    "Logo_Symbol_6x_anim",
    "Logo_Symbol_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Tackle", 0, [
    "High_Win_Tackle_3x_anim",
    "High_Win_Tackle_4x_anim",
    "High_Win_Tackle_5x_anim",
    "High_Win_Tackle_6x_anim",
    "High_Win_Tackle_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Lure", 0, [
    "Lure_symbol_3x",
    "Lure_symbol_4x",
    "Lure_symbol_5x",
    "Lure_symbol_6x",
    "Lure_symbol_7x",
  ]);
  spineSymbolAnimator.createAnim("Wild", 0, [
    "Wild_3x_anim",
    "Wild_4x_anim",
    "Wild_5x_anim",
    "Wild_6x_anim",
    "Wild_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Ten", 0, [
    "Royal_10_3x_anim",
    "Royal_10_4x_anim",
    "Royal_10_5x_anim",
    "Royal_10_6x_anim",
    "Royal_10_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Ace", 0, [
    "Royal_A_3x_anim",
    "Royal_A_4x_anim",
    "Royal_A_5x_anim",
    "Royal_A_6x_anim",
    "Royal_A_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Jack", 0, [
    "Royal_J_3x_anim",
    "Royal_J_4x_anim",
    "Royal_J_5x_anim",
    "Royal_J_6x_anim",
    "Royal_J_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("King", 0, [
    "Royal_K_3x_anim",
    "Royal_K_4x_anim",
    "Royal_K_5x_anim",
    "Royal_K_6x_anim",
    "Royal_K_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Queen", 0, [
    "Royal_Q_3x_anim",
    "Royal_Q_4x_anim",
    "Royal_Q_5x_anim",
    "Royal_Q_6x_anim",
    "Royal_Q_7x_anim",
  ]);

  spineSymbolAnimator.createAnim("Bonus", 0, ["Bonus_3x", "Bonus_4x", "Bonus_5x", "Bonus_6x", "Bonus_7x"]);

  spineSymbolAnimator.createAnim("LegendaryCatch", 0, [
    "Legendary_Catch_3x_anim",
    "Legendary_Catch_4x_anim",
    "Legendary_Catch_5x_anim",
    "Legendary_Catch_6x_anim",
    "Legendary_Catch_7x_anim",
  ]);

  ///FISH
  spineSymbolAnimator.createAnim("SmallFish", 0, [
    "High_Win_Small_Fish_3x_anim",
    "High_Win_Small_Fish_4x_anim",
    "High_Win_Small_Fish_5x_anim",
    "High_Win_Small_Fish_6x_anim",
    "High_Win_Small_Fish_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Carp", 0, [
    "High_Win_Carp_3x_anim",
    "High_Win_Carp_4x_anim",
    "High_Win_Carp_5x_anim",
    "High_Win_Carp_6x_anim",
    "High_Win_Carp_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Salmon", 0, [
    "High_Win_Salmon_3x_anim",
    "High_Win_Salmon_4x_anim",
    "High_Win_Salmon_5x_anim",
    "High_Win_Salmon_6x_anim",
    "High_Win_Salmon_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Trout", 0, [
    "High_Win_Trout_3x_anim",
    "High_Win_Trout_4x_anim",
    "High_Win_Trout_5x_anim",
    "High_Win_Trout_6x_anim",
    "High_Win_Trout_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Bass", 0, [
    "High_Win_Bass_3x_anim",
    "High_Win_Bass_4x_anim",
    "High_Win_Bass_5x_anim",
    "High_Win_Bass_6x_anim",
    "High_Win_Bass_7x_anim",
  ]);
  spineSymbolAnimator.createAnim("Pike", 0, [
    "High_Win_Pike_3x_anim",
    "High_Win_Pike_4x_anim",
    "High_Win_Pike_5x_anim",
    "High_Win_Pike_6x_anim",
    "High_Win_Pike_7x_anim",
  ]);

  spineSymbolAnimator.ready = true;
};

spineSymbolAnimator.createAnim = function (name, index, animNames = undefined) {
  let spineAnim = undefined;
  let backings = [];
  let symbolId;
  for (let index = 0; index < spineSymbolAnimator.symbolIDMap.length; index++) {
    if (spineSymbolAnimator.symbolIDMap[index].name === name) {
      symbolId = spineSymbolAnimator.symbolIDMap[index].id;
      break;
    }
  }

  let animNamesCheck = animNames;

  let found = false;

  //Search for pool name
  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    //If pool name exists add a new anim there
    if (poolType.poolName === name) {
      found = true;

      animNamesCheck = poolType.anims;

      spineAnim = resourceManager.createObject(
        "spine",
        "SpineSymScale" + name + index,
        spineSymbolAnimator.slotContainer,
        {
          name: name,
          defaultAnimation: animNamesCheck[0],
          scaleX: 1,
          scaleY: 1,
        }
      );

      //create backings

      for (let i = 0; i < poolType.backingPool.fileNames.length; i++) {
        const backingFileName = poolType.backingPool.fileNames[i];

        const backing = resourceManager.createObject(
          "sprite",
          name + index + "SpineSymBacking" + i,
          spineSymbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
      }

      poolType.pool.push(spineAnim);
      poolType.number++;
      poolType.backingPool.pool.push([backings]);

      break;
    }
  }

  if (!found) {
    //Otherwise create a new anim pool with this name
    spineAnim = resourceManager.createObject(
      "spine",
      "SpineSymScale" + name + index,
      spineSymbolAnimator.slotContainer,
      {
        name: name,
        defaultAnimation: animNamesCheck[0],
        scaleX: 1,
        scaleY: 1,
      }
    );

    //create backings
    const fileNames = [];

    for (let i = 0; i < animNamesCheck.length; i++) {
      const symbolIdOffset = i * 20;
      const backingFileName = spineSymbolAnimator.getSymbolBackingFileName(symbolId + symbolIdOffset);

      if (backingFileName) {
        const backing = resourceManager.createObject(
          "sprite",
          name + index + "SpineSymBacking" + i,
          spineSymbolAnimator.backingContainer,
          {
            fileName: backingFileName,
            scale: 1,
            anchor: 0.5,
          }
        );
        backing.visible = false;
        backings.push(backing);
        fileNames.push(backingFileName);
      }
    }

    spineSymbolAnimator.animationPool.push({
      poolName: name,
      number: 0,
      pool: [spineAnim],
      anims: animNamesCheck,
      backingPool: {
        pool: [backings],
        fileNames: fileNames,
      },
    });
  }

  spineAnim.visible = false;

  return { spine: spineAnim, backings: backings };
};

spineSymbolAnimator.findSpineAndBacking = function (symbolId) {
  let spine = undefined;
  let location = 0;
  //symbolId = symbolId % 20;
  let spineAnimName = spineSymbolAnimator.symbolIDMap[symbolId].name;

  if (spineAnimName === "Empty") {
    return undefined;
  }

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        spine = poolType.pool[0];
        backings = poolType.backingPool.pool[0];

        poolType.pool.splice(0, 1);
        poolType.backingPool.pool.splice(0, 1);
        return { spine: spine, backings: backings };
      }
    }
  }

  spineAndbackings = spineSymbolAnimator.createAnim(spineAnimName, number + 1);
  spineSymbolAnimator.animationPool[location].pool.pop();
  spineSymbolAnimator.animationPool[location].backingPool.pool.pop();

  return spineAndbackings;
};

spineSymbolAnimator.animate = function (symbols, callback, callBackDelay, loop = false) {
  spineSymbolAnimator.finishedCallback = callback;
  spineSymbolAnimator.callBackDelay = callBackDelay;

  const spines = [];
  for (let i = 0; i < symbols.length; i++) {
    let symbol = symbols[i];
    spines.push(spineSymbolAnimator.animateSymbol(symbol, loop));
  }

  return spines;
};

spineSymbolAnimator.animateSymbol = function (symbol, loop) {
  let id;
  let sizeOffset;

  // The coin (fish) symbols go from 101 to 129
  if (symbol.symbolId >= spineSymbolAnimator.startCashFishID) {
    sizeOffset = spineSymbolAnimator.fishSymbolMapOffset.find((offsetData) => symbol.symbolId <= offsetData.max).offset;
    id = symbol.symbolId - spineSymbolAnimator.numCashFish * sizeOffset;
  } else {
    id = symbol.symbolId % 20;
    sizeOffset = Math.floor(symbol.symbolId / 20);
  }

  const reel = symbol.cell.reel;
  const row = symbol.cell.row;

  let symbolMapIndex = undefined;

  for (let index = 0; index < spineSymbolAnimator.symbolIDMap.length; index++) {
    if (spineSymbolAnimator.symbolIDMap[index].id === id) {
      symbolMapIndex = index;
      break;
    }
  }

  let spineAndBacking = spineSymbolAnimator.findSpineAndBacking(symbolMapIndex);

  if (spineAndBacking === undefined) {
    return;
  }

  let animNum =
    spineSymbolAnimator.symbolIDMap[symbolMapIndex].anim === 0 && sizeOffset > 0
      ? 1 * sizeOffset
      : spineSymbolAnimator.symbolIDMap[symbolMapIndex].anim * sizeOffset;
  let animNames = spineSymbolAnimator.findAnimNames(symbolMapIndex);

  let symbolToHide = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
  symbolToHide.visible = false;
  const spine = spineAndBacking.spine;
  const backing = spineAndBacking.backings[animNum];

  if (backing) backing.visible = true;

  let animationObject = {
    anim: spine,
    reel: reel,
    row: row,
    backing: backing,
    symbolToHide: symbolToHide,
    sizeOffset,
  };

  spineSymbolAnimator.currentAnimations.push(animationObject);

  spineSymbolAnimator.positionAnim(animationObject);

  spine.visible = true;
  spine.anim = animNames[animNum];
  spine.play(animNames[animNum], loop, 0, () => {
    spineSymbolAnimator.animationFinished(animationObject);
    spineSymbolAnimator.returnToPool(
      spineSymbolAnimator.symbolIDMap[symbolMapIndex].name,
      spine,
      spineAndBacking.backings
    );
    symbolToHide.visible = true;
  });

  return spine;
};

spineSymbolAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.visible = false;
    if (animationObject.backing) animationObject.backing.visible = false;
    animationObject.symbolToHide.visible = true;
    spineSymbolAnimator.currentAnimations.splice(spineSymbolAnimator.currentAnimations.indexOf(animationObject), 1);
  }

  if (spineSymbolAnimator.currentAnimations.length === 0) {
    if (spineSymbolAnimator.finishedCallback) {
      if (spineSymbolAnimator.callBackDelay !== undefined) {
        spineSymbolAnimator.completeCallback = spineSymbolAnimator.finishedCallback;
        timerManager.addTimeout(spineSymbolAnimator.callBackDelay, function () {
          if (spineSymbolAnimator.completeCallback) {
            spineSymbolAnimator.completeCallback();
          }
        });
      } else {
        spineSymbolAnimator.finishedCallback();
      }
    }
  }
};

spineSymbolAnimator.findAnimNames = function (symbolId) {
  let spineAnimName = spineSymbolAnimator.symbolIDMap[symbolId].name;

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === spineAnimName) {
      animNames = poolType.anims;
      return animNames;
    }
  }

  return undefined;
};

spineSymbolAnimator.returnToPool = function (name, spine, backings) {
  for (let index = 0; index < backings.length; index++) {
    const backing = backings[index];
    backing.visible = false;
  }

  for (let i = 0; i < spineSymbolAnimator.animationPool.length; i++) {
    let poolType = spineSymbolAnimator.animationPool[i];

    if (poolType.poolName === name) {
      poolType.pool.push(spine);
      poolType.backingPool.pool.push(backings);
    }
  }
};

spineSymbolAnimator.positionAnim = function (animationObject) {
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const reelObject = resourceManager.get("slotContainer:reelContainer:reel" + reel);
  const reelScale = reelObject.scale.x;

  symbol = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);

  const symbolPos = helper.getLocalFromGlobalPosition(symbol, anim, false);

  symbolPos.x = symbolPos.x + symbol.width / 2;
  symbolPos.y = symbolPos.y + symbol.height / 2;

  const animName = anim.Props.name;

  let offsets = spineSymbolAnimator.fishNames.includes(animName)
    ? spineSymbolAnimator.fishSpinePositionOffsets[animationObject.sizeOffset]
    : { x: 0, y: 0 };

  anim.position.set(symbolPos.x + offsets.x, symbolPos.y + offsets.y);
  anim.scale.set(reelScale);
  if (animationObject.backing) {
    animationObject.backing.position.set(symbolPos.x, symbolPos.y);
    animationObject.backing.scale.set(reelScale / 2);
  }
};

spineSymbolAnimator.getSymbolBackingFileName = function (symbolId) {
  let sizeOffset = Math.floor(symbolId / 20);
  const id = symbolId % 20;
  let fileName;

  if (symbolId >= 100 || id === 12 || id === 14 || id === 18 || id === 19) {
    fileName = undefined;
  } else {
    switch (sizeOffset) {
      case 0:
        fileName = "Symbols/symbolstatics/x3/BACK_BORDER_x3.png";
        break;
      case 1:
        fileName = "Symbols/symbolstatics/x4/BACK_BORDER_x4.png";
        break;
      case 2:
        fileName = "Symbols/symbolstatics/x5/BACK_BORDER_x5.png";
        break;
      case 3:
        fileName = "Symbols/symbolstatics/x6/BACK_BORDER_x6.png";
        break;
      case 4:
        fileName = "Symbols/symbolstatics/x7/BACK_BORDER_x7.png";
        break;
    }
  }

  return fileName;
};

spineSymbolAnimator.skip = function () {
  spineSymbolAnimator.currentAnimations.forEach((animation) => {
    spineSymbolAnimator.returnToPool(animation.anim.name, animation.anim, animation.backing);
    animation.anim.visible = false;
    animation.symbolToHide.visible = true;
    if (animation.backing) {
      spineSymbolAnimator.backings.splice(spineSymbolAnimator.currentAnimations.indexOf(animation.backing), 1);
      resourceManager.destroyObject(animation.backing.name);
    }
  });

  spineSymbolAnimator.currentAnimations = [];
  spineSymbolAnimator.finishedCallback = undefined;
};

spineSymbolAnimator.orientationChange = function () {
  if (spineSymbolAnimator.ready) {
    timerManager.addTimer(5, () => {
      spineSymbolAnimator.currentAnimations.forEach((animationObject) => {
        spineSymbolAnimator.positionAnim(animationObject);
      });
      ///gameData.winningsText.resetPosition();
    });
  }
};

Reflex.registerEventHandler("layoutChange", spineSymbolAnimator.orientationChange);
